export type AppAlertTone = "info" | "error";

export interface AppAlertOptions {
  title?: string;
  buttonText?: string;
  tone?: AppAlertTone;
}

export interface AppAlertDetail extends AppAlertOptions {
  message: string;
}

export function showAppAlert(message: string, options: AppAlertOptions = {}) {
  window.dispatchEvent(
    new CustomEvent<AppAlertDetail>("app:alert", {
      detail: { message, ...options },
    }),
  );
}
